import {ref} from 'vue'


export const themesOfAppeal = ref([
    {
        name: 'Изменение регистрационных данных',
        code: 'registred data'
    },
    {
        name: 'Изменение персональных данных',
        code: 'personal data'
    },
    {
        name: 'Изменение каких-то данных',
        code: 'any data'
    },
    {
        name: 'Изменение данных',
        code: 'data'
    }
])